import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useField, useFormikContext } from "formik";
import styles from "../../styles/PhoneInput.module.css";
import tr from "react-phone-input-2/lang/tr.json";
const PhoneInputW = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);

  const { setError, setValue, setTouched } = helpers;

  const { values, submitForm, submitCount, setFieldValue } = useFormikContext();
  const [country, setCountry] = useState({
    name: "Turkey",
    dialCode: "90",
    countryCode: "tr",
    format: "+.. ... ... .. ..",
  });
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (country) {
      const pattern = new RegExp(
        `^\\d{${country.format.replaceAll(" ", "").replace("+", "").length}}$`,
      );
      if (!meta.touched) setTouched(true);

      if (props.isrequired == "required") {
        if (country.countryCode == "tr") {
          setIsError(pattern.test(field.value) == false);
          setFieldValue(props.validname, !(pattern.test(field.value) == false));
        } else {
          setIsError(false);
          setFieldValue(props.validname, true);
        }

        //setFieldValue(props.validname, true);
      } else {
        if (field.value.length <= country.dialCode.length) {
          setTouched(false);
          setFieldValue(props.validname, true);
          setError(false);
        } else {
          //setIsError(pattern.test(val) == false);
          if (!meta.touched) setTouched(true);
          //setFieldValue(
          //  props.validname,
          //  pattern.test(val) == true ? true : null
          //);
          setFieldValue(props.validname, true);
        }
      }
    }
  }, [field.value]);

  return (
    <div
      className={`relative text-brand-gray-9 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)] flex items-center ${
        props.mode == "simple" ? "h-full border px-6" : "h-[70px]  px-9"
      }  ${
        !meta.error && meta.touched && !isError
          ? `${
              props.mode == "simple" ? "border" : "border-2"
            }  border-green-400`
          : null
      } ${
        (meta.error && meta.touched) ||
        (isError && field.value.length > country.dialCode.length) ||
        (submitCount > 0 && !field.value)
          ? `${props.mode == "simple" ? "border" : "border-2"} border-red-400`
          : null
      }`}
    >
      <span className="font-semibold  text-sm">{label}</span>
      <span className="h-full w-0.25 ml-5 mr-6 flex-1">
        <PhoneInput
          className={styles.PhoneInput}
          localization={tr}
          country={"tr"}
          inputClass={styles.input}
          buttonClass={styles.dropDown}
          preferredCountries={["tr"]}
          enableLongNumbers={true}
          onChange={(value, country, e, formattedValue) => {
            setValue(value);
            setCountry(country);
          }}
          value={field.value}
        ></PhoneInput>
        {props.isrequired && <span className=" absolute right-4 top-4">*</span>}
      </span>
    </div>
  );
};

export default PhoneInputW;
